var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconUnlocked2 = function SvgIconUnlocked2(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 15,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5867 18.7179C31.0411 18.3308 32.5772 18.462 33.9524 19.0908C35.3276 19.7195 36.4634 20.8098 37.1802 22.1896C37.3781 22.5704 37.2435 23.047 36.8796 23.254C36.5157 23.4611 36.0603 23.3203 35.8624 22.9394C35.3049 21.8663 34.4215 21.0182 33.3519 20.5292C32.2823 20.0402 31.0875 19.9382 29.9563 20.2392C28.8251 20.5403 27.822 21.2272 27.1056 22.1915C26.4015 23.1392 26.0137 25.2675 26.0005 26.5H35.25C38.4256 26.5 41 29.1941 41 32.5174V36.7035C41 40.0268 38.4256 42.7209 35.25 42.7209H25.25C22.0744 42.7209 19.5 40.0268 19.5 36.7035V32.5174C19.5 29.46 21.6788 26.9352 24.5002 26.5507C24.503 24.9793 25.0029 22.4643 25.9214 21.228C26.8426 19.9881 28.1323 19.1049 29.5867 18.7179ZM30.25 31.7326C28.7312 31.7326 27.5 33.0211 27.5 34.6105C27.5 36.1999 28.7312 37.4884 30.25 37.4884C31.7688 37.4884 33 36.1999 33 34.6105C33 33.0211 31.7688 31.7326 30.25 31.7326Z",
    fill: "url(#paint0_linear_16_7904)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16_7904",
    x1: 4.39342,
    y1: 30.6105,
    x2: 45.6961,
    y2: 30.6105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3499FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A3985"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconUnlocked2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/IconUnlocked2.1ee40a89d5959d5c51a8e4761c14a5f7.blank.svg";